import Siema from 'siema';

const gallery = () => {
  const siema = new Siema({
    onChange() {
      autoHeight();
    },
  });

  const autoHeight = () => {
    let min, max, itemHeightList, height, maxHeight, i;

    min = siema.currentSlide;
    max =  min + siema.perPage;
    itemHeightList = [];

    for (i = min; i < max; i++) {
        height = parseInt(siema.innerElements[i].scrollHeight, 10);
        itemHeightList.push(height);
    }

    maxHeight = Math.max.apply(null, itemHeightList);

    siema.selector.style.maxHeight = maxHeight + 'px';
  }

  window.addEventListener('resize', function () {
    let timeout;
    siema.sliderFrame.style.maxHeight = '';
    clearTimeout(timeout);
    timeout = setTimeout(autoHeight, 500);
  });

  window.addEventListener('keydown', e => {
    if(e.keyCode == 37) {
      siema.prev();
    } else if (e.keyCode == 39) {
      siema.next();
    }
  });

  document.querySelector('.c-gallery__prev').addEventListener('click', () => siema.prev());
  document.querySelector('.c-gallery__next').addEventListener('click', () => siema.next());

  setTimeout(siema.resizeHandler, 500);
  setTimeout(autoHeight, 500);
};

export default gallery;


// WEBPACK FOOTER //
// ./scripts/modules/gallery.js